export default __webpack_public_path__ + "static/media/hackathon-level-5.c7d51418.svg";